import { type SkeletonProps } from "./skeleton";
import { KeyValueObject } from "../types/general";

export function getBorderRadius(rounded: SkeletonProps["rounded"], theme: any): KeyValueObject | null {
    if (rounded === "md") {
        return { borderRadius: theme.borderRadius.DEFAULT };
    }
    if (rounded === "lg") {
        return { borderRadius: theme.borderRadius.lg };
    }
    if (rounded === "full") {
        return { borderRadius: theme.borderRadius.full };
    }
    return null;
}
